export default __webpack_public_path__ + "static/favicon-87850139090afbc44dd3ed76943a219f.png";